import { render, staticRenderFns } from "./LLCheckbox.vue?vue&type=template&id=bb101438&scoped=true"
import script from "./LLCheckbox.vue?vue&type=script&lang=js"
export * from "./LLCheckbox.vue?vue&type=script&lang=js"
import style0 from "./LLCheckbox.vue?vue&type=style&index=0&id=bb101438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb101438",
  null
  
)

export default component.exports